"use client";
import { IconPlus, IconX } from "@tabler/icons-react";
import InputField from "../../../components/common/InputField";
import SelectInput from "../../../components/common/SelectInput";
import { useState } from "react";
const AddWeightRangeModal = () => {
  const [forClient, setForClient] = useState(true);
  const [weightRanges, setWeightRanges] = useState([{ from: "", to: "" }]);

  const handleAddRange = () => {
    setWeightRanges([...weightRanges, { from: "", to: "" }]);
  };

  const handleRemoveRange = (index: number) => {
    const newRanges = [...weightRanges];
    newRanges.splice(index, 1);
    setWeightRanges(newRanges);
  };

  return (
    <div className="w-[655px] max-h-[520px] overflow-y-auto overflow-hidden p-4 space-y-4">
      {weightRanges.map((range, index) => (
        <div key={index} className="flex items-center gap-3">
          <InputField
            className="flex-1"
            label="From (kg)"
            type="text"
            placeholder="Enter from kg"
            value={range.from}
            onChange={(e) => {
              const newRanges = [...weightRanges];
              newRanges[index].from = e.target.value;
              setWeightRanges(newRanges);
            }}
          />
          <InputField
            className="flex-1"
            label="To (kg)"
            type="text"
            placeholder="Enter to kg"
            value={range.to}
            onChange={(e) => {
              const newRanges = [...weightRanges];
              newRanges[index].to = e.target.value;
              setWeightRanges(newRanges);
            }}
          />
          {index === weightRanges.length - 1 ? (
            <button
              type="button"
              onClick={handleAddRange}
              className="mt-7 bg-[#FBD037]/20 border border-[#FBD037] rounded-full p-2"
            >
              <IconPlus size={18} className="text-black" />
            </button>
          ) : (
            <button
              type="button"
              onClick={() => handleRemoveRange(index)}
              className="mt-7 bg-red-100 border border-red-300 rounded-full p-2"
            >
              <IconX size={18} className="text-red-600" />
            </button>
          )}
        </div>
      ))}

      <div className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          id="forClient"
          checked={forClient}
          onChange={() => setForClient(!forClient)}
          className="accent-[#FFCD4B] cursor-pointer scale-105"
        />
        <label
          htmlFor="forClient"
          className="text-sm text-[#1E293B] cursor-pointer"
        >
          For Client
        </label>
      </div>

      <SelectInput label={"Select Client"} />
    </div>
  );
};

export default AddWeightRangeModal;
